import { Collection } from 'modules/core/lib/mobx-rest'

import ContractVersion from 'modules/contracts/store/models/ContractVersion'

export class ContractVersions extends Collection<ContractVersion> {
  get cacheKey(): string {
    return 'contractVersions'
  }

  get indexes() {
    return ['employee_id', 'effective_on']
  }

  model() {
    return ContractVersion
  }
}

const singleton = new ContractVersions()

export default singleton
